import React, { useEffect, ReactNode, useMemo } from "react";
import { Redirect, Route, RouteProps, useLocation } from "react-router";
import { LoginScreenOpenId } from "../screens/LoginScreen/LoginScreenOpenId";
import { useSessionContext } from "../Context/AuthContext";
import { clearLocalStorageOnLogout } from "../Helper/localStoreFunction";
import { GetAllMasterData } from "../Services/MasterDataService";
import useMasterSetting from "../hooks/useMasterSetting";

export type ProtectedRouteProps = {
  isAuthenticated: boolean;
  authenticationPath: string;
  redirectPath: string;
  setRedirectPath: (path: string) => void;
  children?: ReactNode;
} & RouteProps;

export default function PrivateRoute({
  isAuthenticated,
  authenticationPath,
  redirectPath,
  setRedirectPath,
  children,
  ...routeProps
}: ProtectedRouteProps) {
  const currentLocation = useLocation();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  let paramString = window.location.href.split("#")[1];
  const codeURLSearch = new URLSearchParams(paramString);
  const _codeUrl = codeURLSearch.get("code");
  const [sessionContext, updateSessionContext] = useSessionContext();
  const { masterSetting, getMasterSettingAll } = useMasterSetting();
  const masterTimeout = masterSetting["Timeout"];
  
  useEffect(() => {
    if (!isAuthenticated) {
      if (query.get("MemoID")) {
        localStorage.setItem("memoid", query.get("MemoID") || "");
      }
      return;
    }

    localStorage.removeItem("memoid");
    chaeckLastActtion();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setRedirectPath("/login");
    }
  }, [isAuthenticated, currentLocation]);

  const chaeckLastActtion = async () => {
    try {
      const lastActionRaw = localStorage.getItem("lastAction");
      if (!lastActionRaw) return;

      const lastAction = Number(lastActionRaw);

      const diffMilliseconds = Date.now() - lastAction;

      let timeout = Number(localStorage.getItem("timer")) || 60 * 60 * 1000; // default 1 ชั่วโมง

      if (masterTimeout && masterTimeout.IsActive) {
        if (masterTimeout.Value2 != null) {
          timeout = Number(masterTimeout.Value2) * 60 * 1000;
        }
      }

      console.log("Timeout:", timeout, "Diff:", diffMilliseconds);

      localStorage.setItem("timer", timeout.toString());

      if (diffMilliseconds >= timeout) {
        updateSessionContext({ ...sessionContext, isAuthenticated: false });
        clearLocalStorageOnLogout();
        setRedirectPath("/login");
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (
    isAuthenticated &&
    redirectPath !== currentLocation.pathname
    && currentLocation.pathname === "/"
  ) {
    return <Redirect to={"/Default"} />;
  } else if (
    isAuthenticated &&
    redirectPath !== currentLocation.pathname &&
    currentLocation.pathname !== "/login"
  ) {
    return (
      <Route {...routeProps} path={routeProps.path}>
        {children}
      </Route>
    );
  } else if (
    // isAuthenticated &&
    // redirectPath !== currentLocation.pathname &&
    paramString &&
    paramString.includes("code")
  ) {
    return (
      <Route {...routeProps}>
        <LoginScreenOpenId PathCodeUrl={_codeUrl} />
      </Route>
    );

    /* </LoginScreenOpenId><h1>Oh my god</h1>; */
  } else {
    return (
      <Redirect
        to={{ pathname: isAuthenticated ? redirectPath : authenticationPath }}
      />
    );
  }
}
